import ApiClient from "../ApiClient";

const appId = process.env.REACT_APP_DEFAULT_APP_ID; // appId per login/session

const PaymentService = {

  // 1 Create Razorpay Order
  async createOrder(payload,agreeToEventUpdates) {
    const resp = await ApiClient.post(`/payments/create-order?agreeToEventUpdates=${agreeToEventUpdates}`, payload);
    return resp;
  },

  // 2 Verify Razorpay Payment
  async verifyPayment(payload) {
    const resp = await ApiClient.post("/payments/verify-payment", payload);
    return resp;
  },

  // 3 Refund Payment
  async refundPayment(payload) {
    const resp = await ApiClient.post("/payments/refund-payment", payload);
    return resp;
  },

   // 4 Create Razorpay Pricing Order
  async createPricingOrder(payload) {
    const resp = await ApiClient.post(`/payments/create-pricing-order`, payload);
    return resp;
  },

  // 5 Verify Razorpay Pricing Payment
  async verifyPricingPayment(payload) {
    const resp = await ApiClient.post("/payments/verify-pricing-payment", payload);
    return resp;
  },

  // 6 Create Razorpay Order for Event Registration via campaign
  async createOrderForRegistration(payload, agreeToEventUpdates, businessAdminId) {
    const resp = await ApiClient.post(`/payments/create-registration-order?agreeToEventUpdates=${agreeToEventUpdates}&businessAdminId=${businessAdminId}`, payload);
    return resp;
  },

  // 7 Verify Razorpay Payment for Event Registration via campaign
  async verifyPaymentForRegistration(payload, businessAdminId) {
    const resp = await ApiClient.post(`/payments/verify-registration-payment?businessAdminId=${businessAdminId}`, payload);
    return resp;
  },

};

export default PaymentService;
